<template>
	<div id="user-settings">
		<div class="the-navbar__user-meta flex items-center">
			<div class="text-right leading-tight">
				<p class="font-semibold capitalize">
					{{ usuarioAutenticado.nome }}
				</p>
				<small
					v-if="(colaborador && colaborador.perfil) || usuarioAutenticado.isSuperUser"
					class="capitalize"
					>{{ usuarioAutenticado.isSuperUser ? 'Super administrador' : empresaPk && colaborador && colaborador.perfil ? (typeof colaborador.perfil === 'string' ? colaborador.perfil : colaborador.perfil.nome) : '' }}</small
				>
			</div>
			<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

				<div class="con-img ml-3">
					<vs-avatar size="large" :src="usuarioAutenticado.fotoThumb"/>
				</div>
				<vs-dropdown-menu class="vx-navbar-dropdown">
					<ul style="min-width: 9rem">
						<li
							class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							@click="abrirPerfil"
						>
							<feather-icon
								icon="UserIcon"
								svgClasses="w-4 h-4"
							></feather-icon>
							<span class="ml-2">Perfil</span>
						</li>
						<li
							class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							@click="() => $navigate({ name: 'logout' })"
						>
							<feather-icon
								icon="LogOutIcon"
								svgClasses="w-4 h-4"
							></feather-icon>
							<span class="ml-2">Logout</span>
						</li>
					</ul>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

		<popup-usuario-perfil ref="popupUsuarioPerfil" :active.sync="popupUsuarioPerfil" />

	</div>
</template>


<script>
import PopupUsuarioPerfil from "../../views/usuario/usuario_perfil/UsuarioPerfil";
import Colaborador from '../../models/Colaborador';
import Usuario from '../../models/Usuario';

export default {
	data() {
		return {
			popupUsuarioPerfil: false,
			colaborador: null,
		}
	},
	components: {
		PopupUsuarioPerfil
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		usuarioAutenticado() {
			return Usuario.getUsuarioAutenticado();
		},
	},
	methods: {
		setColaborador() {
			this.colaborador = Colaborador.getColaborador();
		},
		abrirPerfil() {
			const popupPerfil = this.$refs.popupUsuarioPerfil.$el;
			popupPerfil.click();

			this.popupUsuarioPerfil = true;
		}
	},
	watch: {
		empresaPk() {
			this.setColaborador();
		}
	},
	created() {
		this.setColaborador();
	}
}
</script>

<style lang="scss">
#user-settings {
	@media (max-width: 1000px) {
		padding: 2.5rem 0;
	}
}
</style>
